import React from 'react';
import { Box } from '../box';
import { styled, useDown, useStyleConfig, vui } from '../core';
import { Divider } from '../divider';
import { Link } from '../link';
import { T } from '../t';
import { cs } from '../utils';
import { FooterProvider } from './context';
import FooterColumn from './footerColumn';
import FooterContent from './footerContent';
import FooterHeading from './footerHeading';
import FooterLink from './footerLink';
import FooterRow from './footerRow';
import FooterSection from './footerSection';
import FooterSlimColumn from './footerSlimColumn';
import { defaultLinkedInUrl, FooterTrademark } from './footerTrademark';
/*@formatter:off*/
export const FooterBase = styled.divBox `
  background-color: darkBlue.main;
  color: white;
  padding: 5 3;
`;
/*@formatter:on*/
/** Branded Veracity Footer with trademark and links sections. Controls max-width of the content. */
export const Footer = vui((props, ref) => {
    const { applicationLinks, applicationStaticItems = [], children, className, columns, isApplication = false, linkedIn, size, variant, isSlim, ...rest } = props;
    const context = { size, variant };
    const styles = useStyleConfig('Footer', props);
    if (isApplication) {
        if (!applicationLinks) {
            console.error('Footer: isApplication is true but applicationLinks is not set.');
        }
    }
    const slimLinks = [
        {
            id: 'home',
            text: 'veracity.com',
            url: 'https://www.veracity.com/'
        }
    ];
    columns?.map(column => {
        column.map(section => {
            section.links?.map(link => {
                if (!link)
                    return;
                if (['home', 'support', 'status'].includes(link.id || '')) {
                    slimLinks.push(link);
                }
            });
        });
    });
    const downMd = useDown('md');
    const downLg = useDown('lg');
    return (React.createElement(FooterProvider, { value: context },
        React.createElement(FooterBase, { className: cs('vui-footer', isApplication ? 'vui-footer-app' : '', className), px: isApplication ? '40px' : 3, py: isSlim ? (downMd ? '16px' : '9px') : 5, role: "contentinfo", ...styles.container, ref: ref, ...rest },
            isApplication && (React.createElement(FooterContent, { alignContent: "center", alignItems: "center", maxW: "100%" },
                React.createElement(FooterRow, { alignContent: "space-between", w: 1 },
                    React.createElement(Box, { alignItems: "self-start", columnGap: 3, flex: { xs: '0 0 100%', sm: '0 0 100%', md: '0 0 100%', lg: '0 0 50%' }, py: { xs: 1, sm: 1, md: 1.25, lg: 1.5 }, wrap: true }, applicationLinks?.map((link, index) => (React.createElement(Box, { flex: { xs: '0 0 50%', sm: '0 0 auto' }, key: index, minW: 70 },
                        React.createElement(FooterLink, { ...link }))))),
                    downLg && React.createElement(Divider, { borderColor: "sandstone.main", mb: 0.5, mt: 1, w: 1 }),
                    React.createElement(Box, { centerV: true, columnGap: 3, flex: { xs: '0 0 100%', sm: '0 0 100%', md: '0 0 100%', lg: '0 0 50%' }, justifyContent: { sm: 'center', lg: 'flex-end' }, py: { xs: 1, sm: 1, md: 1.25, lg: 1.5 }, wrap: true },
                        applicationStaticItems?.map((text, index) => (React.createElement(Box, { key: index },
                            React.createElement(T, { size: "sm" }, text)))),
                        React.createElement(Box, null,
                            React.createElement(Link, { fontWeight: "demi", href: linkedIn ?? defaultLinkedInUrl, iconLeft: React.createElement(Link.Icon, { mr: 1, name: "cubCircleLinkedIn", radius: "50%", size: "xs" }), isExternal: true, size: { _: 'sm', md: 'md' }, ...styles.link },
                                React.createElement(FooterHeading, { fontSize: "16px", mb: 0, text: "Follow us" }))))))),
            !isApplication && isSlim && (React.createElement(FooterContent, { alignContent: "center", alignItems: "center", maxW: { xs: 343, sm: 305, md: 720, lg: 975 } },
                React.createElement(FooterRow, null,
                    slimLinks.map((link, index) => {
                        /** if the screen is small drop one specific link */
                        if (downLg && link?.id === 'support')
                            return;
                        return (React.createElement(FooterSlimColumn, { key: index },
                            React.createElement(FooterLink, { ...link })));
                    }),
                    downMd && React.createElement(Divider, { borderColor: "sandstone.main", mb: 0.5, mt: 1, w: 1 }),
                    React.createElement(FooterSlimColumn, { centerV: true },
                        React.createElement(T, { size: "xs" },
                            React.createElement(T, { size: "xs", weight: "demi" }, "Veracity by DNV"),
                            ", DNV AS")),
                    React.createElement(FooterSlimColumn, null,
                        React.createElement(Link, { fontWeight: "demi", href: linkedIn ?? defaultLinkedInUrl, iconLeft: React.createElement(Link.Icon, { mr: 1, name: "cubCircleLinkedIn", radius: "50%", size: "xs" }), isExternal: true, size: { _: 'sm', md: 'md' }, ...styles.link },
                            React.createElement(FooterHeading, { fontSize: "16px", mb: 0, text: "Follow us" })))))),
            !isApplication && !isSlim && (React.createElement(FooterContent, null,
                children ??
                    (columns && (React.createElement(FooterRow, null, columns.map((sections, index) => (React.createElement(FooterColumn, { key: index, sections: sections })))))),
                children || columns ? React.createElement(Divider, { borderColor: "sandstone.main", my: 4 }) : null,
                React.createElement(FooterRow, null,
                    React.createElement(FooterTrademark, { linkedIn: linkedIn })))))));
});
Footer.Column = FooterColumn;
Footer.Content = FooterContent;
Footer.Heading = FooterHeading;
Footer.Link = FooterLink;
Footer.Row = FooterRow;
Footer.Section = FooterSection;
export default Footer;
